import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Chip } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useSelector } from "src/stateManagement/redux";

export const FilesHistorical = () => {
    const { files } = useSelector((state) => state.location);
    const columns: GridColDef[] = [
        { field: "date", headerName: "Tipo", flex: 1 },
        { field: "origin", headerName: "Nombre", flex: 1 },
        { field: "responsable", headerName: "Descripción", flex: 1 },
        {
            field: "tags",
            headerName: "Tags",
            flex: 1,
            renderCell: (params) => {
                return params.row.tags.map((tag: any) => (
                    <Chip
                        color={tag.type}
                        size="small"
                        icon={
                            tag.type === "warning" ? (
                                <WarningAmberIcon />
                            ) : tag.type === "success" ? (
                                <CheckCircleOutlineIcon />
                            ) : tag.type === "error" ? (
                                <ErrorOutlineIcon />
                            ) : undefined
                        }
                        label={tag.name}
                        sx={{ mr: 1 }}
                    />
                ));
            },
        },
        { field: "prof_bomb", headerName: "Subido por", flex: 1 },
        { field: "run_lif", headerName: "Actualizado", flex: 1 },
    ];

    const paginationModel = { page: 0, pageSize: 10 };
    return (
        <Grid container spacing={0}>
            <Grid size={12}>
                <DataGrid
                    rows={files}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{
                        border: 0,
                        mt: 2,
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "#316EBC",
                            color: "#fff",
                            fontWeight: "bold",
                        },
                    }}
                />
            </Grid>
        </Grid>
    );
};
